import { edgeConfig } from '@ory/integrations/next';
import { Configuration, V0alpha2Api } from '@ory/kratos-client';

const api = new V0alpha2Api(new Configuration(edgeConfig));
export default api;